type SiteElementQuantityPickerStatuses = 'Ok' | 'Busy' | 'Error' | 'Unknown';

interface ISiteElementQuantityPickerConfig {
    minQuantity: number;
    maxQuantity: number;
    incrementQuantity: number;
    debtorId: string;
}
interface ISiteElementQuantityPickerSubmit {
    submit(debtorId: string, quantity: number, customFields: {[key: string]: string}): Promise<SiteBuyResponse>
}
interface ISiteElementQuantityPicker
    extends IQueryElement {
    
    valueEvent: IQueryEventAsync<number>;
}
class SiteElementQuantityPicker
    extends QueryElement<HTMLElement>
    implements ISiteElementQuantityPicker {
    
    private _isDisabled: boolean;
    private readonly _product: ISiteElementQuantityPickerSubmit;
    
    private readonly _config: ISiteElementQuantityPickerConfig;
    private readonly _upButton: IQueryElement;
    private readonly _downButton: IQueryElement;
    private readonly _addButton: IQueryElement;
    private readonly _input: IQueryElement;

    private readonly _valueEvent: QueryEventAsync<number>;
    get valueEvent(){ return this._valueEvent.expose(); } 

    constructor(element: HTMLElement, product: ISiteElementQuantityPickerSubmit) {
        super(element);
        var config = this.getAttr("data-config");

        if (config == null)
            throw "Unable to get config";
        
        this._valueEvent = new QueryEventAsync<number>();
        this._config = QueryJSON.deserialize<ISiteElementQuantityPickerConfig>(config);

        this._product = product;
        this._isDisabled = false;

        var upButton = this.query(".up").first();
        var addButton = this.query(".add").first();
        var downButton = this.query(".down").first();
        var input = this.query(".input input").first();

        if (upButton == null || downButton == null || input == null || addButton == null)
            throw "Element(s) not found!";
        
        this._upButton = upButton;
        this._downButton = downButton;
        this._addButton = addButton;
        this._input = input;

        this._upButton.on("click", e => {
            e.stop();
            this.up();
        });
        this._downButton.on("click", e => {
            e.stop();
            this.down();
        });
        this._addButton.on("click", e => {
            e.stop();
            this.submit();
        });

        this.reset();
    }

    up() {
        let value = this.getValue();
        value += this._config.incrementQuantity;

        if (value > this._config.maxQuantity)
            value = this.getValue();

        this.setValue(value);
    }
    down() {
        let value = this.getValue();
        value -= this._config.incrementQuantity;

        if (value < this._config.minQuantity)
            value = this.getValue();
        
        this.setValue(value);
    }
    async submit() {
        if (this._isDisabled)
            return;
        
        this.disable();
        this.setStatus("Busy");
        let successful = await this._product.submit(this._config.debtorId, this.getValue(), {});
        this.enable();

        switch (successful)
        {
            case "Ok":
                this.setStatus("Ok");
                break;
            case "Error":
                this.setStatus("Error")
                break;
            case "Unknown":
                this.setStatus("Unknown");
                break;
        }
        
        window.setTimeout(() => this.resetStatus(), 5000);
        this.reset();
    }
    reset() {
        this.setValue(this._config.minQuantity);
    }
    setStatus(status: SiteElementQuantityPickerStatuses) {
        this.resetStatus();
        this._addButton.addClass(`status-${status.toLowerCase()}`);
    }
    resetStatus() {
        this._addButton
            .removeClass("status-busy")
            .removeClass("status-ok")
            .removeClass("status-error")
            .removeClass("status-unknown");
    }
    buttonCheck() {
        var value = this.getValue();

        if ((value + this._config.incrementQuantity) > this._config.maxQuantity)
            this._upButton.addClass("disabled");
        else
            this._upButton.removeClass("disabled");
        
        if ((value - this._config.incrementQuantity) < this._config.minQuantity)
            this._downButton.addClass("disabled");
        else
            this._downButton.removeClass("disabled");
    }
    enable() {
        this._isDisabled = false;
    }
    disable() {
        this._isDisabled = true;
    }

    setValue(value: number) {
        this._input.setVal(value.toString());
        this._valueEvent.trigger(value);
        this.buttonCheck();
    }
    getValue() {
        let value = this._input.getVal() || "0";

        return parseInt(value);
    }
}